import { render, staticRenderFns } from "./ConstructPacks.vue?vue&type=template&id=5ef489a1"
import script from "./ConstructPacks.vue?vue&type=script&lang=ts"
export * from "./ConstructPacks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports